import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { DatePicker } from './date-picker';
import { TextInput } from './text-input';
/**
 * This component is a styled input for text, number, and other standard input types. See the props table for full details.
 *
 * It also includes a datepicker which is activated when setting `type="date"`.
 *
 * Use this component in conjunction with the `useForm()` hook for handling form state and validation.
 */
export const Input = React.forwardRef((props, ref) => {
    const Component = props.type === 'date' ? DatePicker : TextInput;
    return _jsx(Component, { ...props, ref: ref });
});
//# sourceMappingURL=input.js.map